import { useTbViewStore } from '@vt/hooks'

export const useBindLevel = (areaBindType) => {
  const detailConfig = useTbViewStore((x) => x.detailConfig)

  const bindingConfig =
    detailConfig?.binding?.[areaBindType] || detailConfig?.binding
  return bindingConfig?.level || 'isLastLevel'
}
